<script>
export default {
  name: 'UserAuth',
  computed: {
    userAuth() {
      return this.$root.userAuth || {};
    },
    userLoading() {
      return !this.$root.userAuth;
    },
    userId() {
      return this.userAuth.uid;
    },
    userName() {
      return this.userAuth.displayName;
    },
    userAvatar() {
      return this.userAuth.photoURL;
    },
    userMail() {
      return this.userAuth.email;
    },
    userDevice() {
      return this.$root.userDevice || {};
    },
    userDeviceLoading() {
      return this.$root.userDeviceLoading;
    },
    userDeviceOnline() {
      return this.$root.userDeviceOnline || {};
    },
    userTemperatureUnit: {
      get() {
        return this.$root.userTemperatureUnit || this.$cookie.get('temperature_unit');
      },
      set(val) {
        this.$root.userTemperatureUnit = val;
        this.$cookie.set('temperature_unit', val);
      }
    }
  },
  methods: {
    getUserToken() {
      if (this.$root.userAuth) return this.$root.userAuth.getIdToken(false);
    },
    async doCommand(cmd, dynamic_url) {
      let host = process.env.VUE_APP_API_HOST;
      let token = await this.getUserToken();
      let url = `${host}/${dynamic_url}/${cmd.device.id}`;
      let config = {
        headers: {
          Authorization: token
        }
      }
      try {
        await this.$http.post(url, cmd, config);
      } catch (err) {
        this.$emit('toast', JSON.stringify((((err || {}).response || {}).data || {}).error) || err.message);
      }
    },
    async configDevice(cmd) {
      let host = process.env.VUE_APP_API_HOST;
      let token = await this.getUserToken();
      let url = `${host}/config/${cmd.device.id}`;
      let config = {
        headers: {
          Authorization: token
        }
      }
      try {
        await this.$http.post(url, cmd, config);
      } catch (err) {
        this.$emit('toast', (((err || {}).response || {}).data || {}).error || err.message);
      }
    }
  }
}
</script>
